import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Pointer1 = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M8.55269 11.6684L10.4141 17.0523C10.763 18.0615 12.1779 18.0953 12.5745 17.1039L17.9147 3.75542C18.2862 2.82681 17.3802 1.89793 16.4426 2.24616L2.75163 7.33105C1.75114 7.70264 1.74891 9.11695 2.74822 9.49169L8.55269 11.6684Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
})

export default Pointer1
